module.exports = __webpack_public_path__ + "assets/views/04_dosingAdministration/dosingIcon1.png";